var _rect, _rect2, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerTech2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 46,
    height: 46,
    rx: 8,
    fill: "#FF7140"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19083)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(11.667 11)",
    fill: "#FF7140"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_19083",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.667 11H11.667V35H35.667V11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_19083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1939 11.0982C18.6202 10.2582 12.6082 14.8985 11.7652 21.4729C10.9252 28.0467 15.5655 34.0587 22.1399 34.9017C28.7137 35.7417 34.7257 31.1014 35.5649 24.5269C36.4087 17.9532 31.7692 11.9412 25.1939 11.0982ZM27.6629 18.5862C27.4402 18.5862 27.2287 18.6762 27.0727 18.836L22.6199 23.2849L22.3117 22.9797L21.6704 22.3354C26.0572 17.9607 26.8507 17.9172 27.6622 18.5855L27.6629 18.5862ZM22.8037 23.4447L27.2407 19.004C27.4867 18.746 27.8969 18.7497 28.1437 19.0077C28.3859 19.2695 28.3619 19.6797 28.0889 19.9055L23.3902 24.0304L22.8037 23.4447ZM23.1322 24.1407L22.0304 24.3784C22.0072 24.3822 21.9764 24.3702 21.9644 24.3432C21.9524 24.3192 21.9562 24.2922 21.9764 24.2719L22.6207 23.6277L23.1322 24.1407ZM20.3272 23.6802L21.5032 22.5079L22.3822 23.3869L20.4015 23.8122C20.3662 23.8204 20.3317 23.8054 20.3152 23.7732C20.2965 23.7424 20.304 23.7034 20.3272 23.6802ZM16.683 29.7379C16.6402 29.7342 16.608 29.6952 16.6117 29.6562C16.6155 29.6374 16.6237 29.6209 16.6357 29.6089H16.6395L17.5845 28.6639L18.8077 29.8872L16.683 29.7379ZM19.1077 28.4802C19.0147 28.5312 18.9675 28.6369 18.9907 28.7382L19.194 29.6022C19.2262 29.7274 19.0732 29.8122 18.9832 29.7192H18.9795L17.7532 28.4922L21.5152 24.7339L23.3354 24.3402L24.2062 25.2154C22.9522 26.3164 21.2362 27.4144 19.1077 28.4802ZM24.3862 25.0549L23.5462 24.2149L28.2449 20.09C28.2877 20.051 28.3267 20.0082 28.3619 19.9647C28.2179 21.3087 26.3347 23.2069 24.3862 25.0549ZM28.0462 18.5937H28.0424C26.4052 16.949 28.7182 14.4215 30.4994 15.9057L28.8907 17.5197C28.8434 17.5655 28.8434 17.645 28.8907 17.6907L30.1364 18.938C29.4374 19.2852 28.5974 19.145 28.0462 18.5937ZM30.6202 18.5937C30.5384 18.6755 30.4484 18.7497 30.3509 18.812L29.1442 17.6052L30.6749 16.07C31.3387 16.793 31.3117 17.9022 30.6202 18.5937ZM30.5219 17.051C30.4717 17.0862 30.4522 17.1477 30.4679 17.207C30.5422 17.3547 30.5219 17.531 30.4169 17.6562C30.3659 17.7192 30.3779 17.8055 30.4402 17.855C30.4642 17.8707 30.4912 17.8827 30.5219 17.8827C30.5647 17.8827 30.6052 17.867 30.6277 17.8355C30.8039 17.6247 30.8384 17.3277 30.7177 17.0817C30.6704 17.0195 30.5849 17.0037 30.5219 17.051Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11.667 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerTech2);
export default __webpack_public_path__ + "static/media/careerTech2.1fcd68406a0c7d95163d350c21d433fe.svg";
export { ForwardRef as ReactComponent };